import type { ClipboardEventHandler } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField, type TextFieldProps } from '@mui/material';

import { InnField, type InnFieldProps } from './InnField';

// ----------------------------------------------------------------------

export type RHFInnFieldProps = Omit<InnFieldProps, 'renderInput'> & {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  TextFieldProps?: Omit<TextFieldProps, 'label' | 'error' | 'helperText'>;
};

// ----------------------------------------------------------------------

export const RHFInnField = (props: RHFInnFieldProps) => {
  const { name, label, helperText, TextFieldProps, ...restOfProps } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, ...restOfFiledProps }, fieldState: { error } }) => {
        const reassignedOnChange: InnFieldProps['onChange'] = (_, value) => {
          onChange(value);
        };

        const handlePaste: ClipboardEventHandler<HTMLInputElement> = event => {
          event.preventDefault();

          const clipboardData = event.clipboardData.getData('text');

          onChange(clipboardData.trim());
        };

        return (
          <InnField
            {...restOfFiledProps}
            onChange={reassignedOnChange}
            onPaste={handlePaste}
            renderInput={inputParams => (
              <TextField
                error={!!error}
                label={label}
                placeholder="Поиск"
                helperText={error ? error?.message : helperText}
                {...TextFieldProps}
                {...inputParams}
              />
            )}
            {...restOfProps}
          />
        );
      }}
    />
  );
};
